

import { Fragment, } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { useContext, useEffect, useState } from 'react'
import { generatePath, matchPath, useLocation, useNavigate, useSearchParams } from "react-router-dom"
import { cls, usePathname, useSyncState, CustomContext } from 'pages/Root'
import RoutePathDefinition from 'pages/routes/RoutePathDefinition'

import close_btn from 'images/menu_close_btn.png'
import drawer_logo from 'images/drawer_logo.png'
import Spinner from './Spinner'

function Drawer({navigateImpl}){
  const customData =useContext(CustomContext)
  const pathname =usePathname()
  const navigate =useNavigate()
  const searchParams =useSearchParams()

  if (pathname[2].current ===null){
    return null;
  }
  
  return(
    <Transition.Root show={customData['drawerState'][0]} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={customData['drawerState'][1]}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 left-0 flex max-w-full">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-200 sm:duration-200"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-200 sm:duration-200"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto relative w-screen overflow-hidden">
                  <div className="relative h-[calc(100*var(--vh))] w-[100vw] bg-white column items-center justify-center">
                    <button className="absolute right-0 top-0 w-[50px] pr-[15px] pt-[17px]" onClick={(e)=>{
                      customData['drawerState'][1](!customData['drawerState'][2].current)
                    }}>
                      <img src={close_btn}/>
                    </button>
                    <div className="col-auto column items-center justify-center [&&]:max-h-[80%] w-full">
                      <div className="col-auto w-[32vw] MQ-MBL:w-[calc(18*var(--vh))]">
                        <img src={drawer_logo}/>
                      </div>
                      <div className="col column overflow-y-auto w-full">
                        {customData.manualData[0]&&[...(customData.filteredManualData[0]?[customData.filteredManualData[0]]:[]), ...customData.manualData[0].filter(v=>v.list?.some(vs=>vs.public||searchParams[0].get('admin')==='1'))]?.map((v,idx)=>{
                          //...
                          return <button key={idx} className="col-auto [&&]:h-[17vw] MQ-MBL:[&&]:h-[calc(9.59*var(--vh))] w-full column items-center group" onClick={(e)=>{
                            var nav_str =`?type=${v.name}`
                            if (searchParams[0].has('filter')){
                              nav_str+='&filter='+searchParams[0].get('filter')
                            }
                            if (searchParams[0].has('admin')){
                              nav_str+='&admin='+searchParams[0].get('admin')
                            }
                            customData['drawerState'][1](!customData['drawerState'][2].current)

                            if (searchParams[0].has('type')&&searchParams[0].get('type')===v.name){
                              //navigate to the same category
                              // console.log('74 -', customData.parentHtmlRef)
                              customData.parentHtmlRef.current?.scrollTo(0, 0)
                            }else{
                              navigate(nav_str)
                            }
                          }}>
                            <div className="col row w-full items-center justify-center">
                              <label className={cls(" pointer-events-none text-[20px] text-[#47bff4] font-bold truncate max-w-[70%]")}>{(v.name==='搜尋'&& searchParams[0].get('filter'))?`搜尋 : ${searchParams[0].get('filter')}`:v.name}</label>
                            </div>
                            <div className="col-auto w-[30vw] MQ-MBL:w-[calc(16.86*var(--vh))] [&&]:h-[2px] bg-[#d8effb]"/>
                          </button>
                        })}
                      </div>
                    </div>

                  </div>

                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}

export default Drawer